import { Component, OnDestroy, Renderer2, inject } from '@angular/core';
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'nwm-account',
    templateUrl: './account.component.html',
    imports: [MenuComponent, NgClass, RouterOutlet]
})

export class AccountComponent implements OnDestroy {
  private renderer = inject(Renderer2);


  constructor() {
    this.renderer.addClass(document.body, 'img_bg');
   }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'img_bg');
  }
}